// extracted by mini-css-extract-plugin
module.exports = {"card":"card--2lVnx","cardHeader":"cardHeader--2Dwoz","cardBody":"cardBody--2gayy","cardFooter":"cardFooter--1K0Vv"};